export default __webpack_public_path__ + "static/hw_ff_ky_040_schem-89ab257ab7c2f7c4ad3a48ef8862453c.png";